import React from 'react';
import { withTranslation } from 'react-i18next';
import './Summary.scss';
import PropTypes from 'prop-types';

const Summary = ({ t, info, children }) => {
  return (
    <div className="sor-summary">
      <div className="sor-summary--heading">
        {info.sendingNationName ? `${info.sendingNationName} - ` : null}
        {info.annexName || t('All')}
      </div>
      <div className="sor-summary--items">
        <div className="sor-summary--item">
          <div className="sor-summary--item-label">{t('Total req.')}</div>
          <div className="sor-summary--item-result">
            {info.requestedQuantity}
          </div>
        </div>
        <div className="sor-summary--item">
          <div className="sor-summary--item-label">{info.organization}</div>
          <div className="sor-summary--item-result">
            {info.responsiblePerson.email ? (
              <a
                href={`mailto:${info.responsiblePerson.email}`}
                title={info.responsiblePerson.name}
              >
                {info.responsiblePerson.name}
              </a>
            ) : (
              info.responsiblePerson.name
            )}
          </div>
        </div>
        <div className="sor-summary--item">
          <div className="sor-summary--item-label">{t('Phone')}</div>
          <div className="sor-summary--item-result">
            {info.responsiblePerson.phone}
          </div>
        </div>
        {children && <div className="sor-summary--item">{children}</div>}
      </div>
    </div>
  );
};

Summary.propTypes = {
  country: PropTypes.string,
  t: PropTypes.func,
  info: PropTypes.object,
  children: PropTypes.any
};

export default withTranslation()(Summary);
